import { useLocation } from 'react-router-dom';

const GetQueryParam = (queryName: string) :  string | null =>  {
    return new URLSearchParams(useLocation().search).get(queryName);
}

export default GetQueryParam